import React, {useState, useEffect, useRef} from 'react';
import formService from '../../services/form-service';
import {defaultErrorHandler} from '../../context/context';
import CenteredSpinner from '../../libs/react-components-admin/spinners/centered-spinner';
import FormSelector from './form-selector';

const MultiFormSelector = ({initialValue, onChange}) => {

  const addButtonRef = useRef(null);
  const [value, setValue] = useState(initialValue || []);
  const [forms, setForms] = useState();

  useEffect(() => { onChange(value); }, [value]);

  useEffect(() => {
    formService.findAllFormsCreatingDefaultIfEmpty()
      .then(forms => setForms(forms))
      .catch(defaultErrorHandler);
  }, []);

  const updateValueWithRefresh = v => {
    setValue(null);
    setTimeout(() => {
      setValue(v);
      if ((addButtonRef.current || {}).scrollIntoView) {
        addButtonRef.current.scrollIntoView();
      }
    }, 0);
  };

  if (!value) {
    return <></>;
  } else if (!forms) {
    return <CenteredSpinner/>;
  }
  return <ul className="list-group">
    {value.map((formId, index) => <li key={formId} className="list-group-item">
      <div className="row">
        <div className="col">
          <FormSelector label=""
                        className="mb-0"
                        forms={forms.filter(f => f.id === formId || !value.includes(f.id))}
                        allowNull={false}
                        hideWhenNoChoice={false}
                        initialValue={formId}
                        onChange={v => {
                          if (value[index] === v) {
                            return;
                          }
                          updateValueWithRefresh(value.map((id, i) => i === index ? v : id));
                        }}/>
        </div>
        <div className="col-auto">
          <button type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() => updateValueWithRefresh(value.filter(id => id !== formId))}>
            <span className="material-icons align-middle">&#xE872;</span>
          </button>
        </div>
      </div>
    </li>
    )}
    <li className="list-group-item" ref={addButtonRef}>
      <div className="row">
        <div className="col">
        </div>
        <div className="col-auto">
          <button type="button"
                  className="btn btn-sm btn-success"
                  onClick={() => updateValueWithRefresh([...value, forms.map(f => f.id).find(id => !value.includes(id))])}
                  disabled={value.length >= forms.length}>
            <span className="material-icons align-middle">&#xE145;</span>
          </button>
        </div>
      </div>
    </li>
  </ul>;
};

export default MultiFormSelector;
